<script setup lang="ts">
import { useBaseStore } from "@/stores/base";
import NavGroup from "./components/NavGroup.vue";
import NavItem from "./components/NavItem.vue";
import NavCollapse from "./components/NavCollapse.vue";
import { useBrandingStore } from "@/stores/brandingStore";

const brandingStore = useBrandingStore();
const store = useBaseStore();
</script>

<template>
	<div class="px-1 py-1" style="min-height: 75px; position: relative">
		<img
			v-show="store.navigationSidebarCollapsed"
			:key="'square'"
			:src="brandingStore.logoSquare"
			alt="logo"
			height="67"
			class="position-absolute"
		/>

		<img
			v-show="!store.navigationSidebarCollapsed"
			:key="'light'"
			:src="brandingStore.logoLight"
			alt="logo"
			height="67"
			class="position-absolute"
		/>
	</div>

	<perfect-scrollbar class="scrollnavbar" :options="{ suppressScrollX: true }">
		<v-list class="pa-3 pt-0">
			<div
				v-for="group in store.navigationStructure"
				:key="group.translation_key"
				class="mb-3"
			>
				<!---Item Sub Header -->
				<NavGroup
					:item="group"
					v-if="group?.navigation_items?.length > 0 && group.is_visible"
				/>
				<template v-for="(item, i) in group.navigation_items">
					<!---If Has Child -->
					<NavCollapse
						class="leftPadding"
						:item="item"
						:level="0"
						v-if="false && item.is_visible"
					/>
					<!---Single Item-->
					<NavItem
						:item="item"
						v-else-if="item.is_visible"
						class="leftPadding"
					/>
					<!---End Single Item-->
				</template>
			</div>
			<!---Menu Loop -->
		</v-list>
	</perfect-scrollbar>
</template>

<style scoped lang="scss">
.scrollnavbar {
	height: calc(100vh - 75px) !important;
}
</style>
